module.exports = __webpack_public_path__ + "static/media/dialmon_200.277fbe27.ico";